// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__68pYR","rootSmall":"AddTileButton_rootSmall__3PSl3"};